import React, { useState, useEffect } from "react";
import { WEDDING } from "../utils/config";

/*
  HOW TO ADD YOUR REAL PHOTOS
  ─────────────────────────────────────────────────────
  1. Put your .jpg/.png files in:  src/assets/photos/
  2. Import them at the top:
       import photo1 from '../assets/photos/proposal.jpg';
       import photo2 from '../assets/photos/engagement.jpg';
       import photo3 from '../assets/photos/together.jpg';
       import photo4 from '../assets/photos/family.jpg';
  3. Replace each `bg:` with `photo: photo1` etc.
  4. In the slide div, switch the style from:
         background: slide.bg
       to:
         backgroundImage: `url(${slide.photo})`
  ─────────────────────────────────────────────────────


import photo2 from "../assets/photos/engagement.jpg";
import photo3 from "../assets/photos/together.jpg";
import photo4 from "../assets/photos/family.jpg";
*/
import photo1 from "../assets/photos/couple13.jpg";
import photo2 from "../assets/photos/engagementring.jpeg";
import photo3 from "../assets/photos/laugh1.jpeg";
import photo4 from "../assets/photos/couple6.jpeg";
import photo5 from "../assets/photos/couple11.jpeg";
import photo6 from "../assets/photos/Zizi.jpeg";
import photo7 from "../assets/photos/mbatsh1.jpeg";
const SLIDES = [
  {
    photo: photo1,
    position: "center 30%",
  },
  {
    photo: photo2,
    position: "center center",
  },
  {
    photo: photo3,
    position: "center 50%",
  },
  {
    photo: photo4,
    position: "center 50%",
  },
  {
    photo: photo5,
    position: "center 30%",
  },
  {
    photo: photo6,
    position: "center 18%",
  },
  {
    photo: photo7,
    position: "center 18%",
  },
];
/*
  {
    bg: "linear-gradient(145deg,#0a1208 0%,#152018 35%,#2D4A35 60%,#4A7250 82%,#9ECFBE 100%)",
  },
  {
    bg: "linear-gradient(132deg,#080e09 0%,#111f13 30%,#243C28 55%,#5a8262 78%,#B8E8DA 100%)",
  },
  {
    bg: "linear-gradient(160deg,#0c1a0d 0%,#1E3028 38%,#4A7250 65%,#7A9E7E 88%,#DFF0DC 100%)",
  },
];
*/
const INTERVAL = 5000;

export default function Hero() {
  const [cur, setCur] = useState(0);
  const [prev, setPrev] = useState(null);
  const [out, setOut] = useState(false);

  useEffect(() => {
    const id = setInterval(() => {
      setPrev(cur);
      setOut(true);
      setCur((c) => (c + 1) % SLIDES.length);
      setTimeout(() => {
        setPrev(null);
        setOut(false);
      }, 1200);
    }, INTERVAL);
    return () => clearInterval(id);
  }, [cur]);

  const bgStyle = (slide) => ({
    position: "absolute",
    inset: 0,
    // background: slide.bg,
    // backgroundImage: `url(${slide.photo})`,
    //swap to this when you have real photos:
    backgroundImage: `url(${slide.photo})`,
    backgroundSize: "cover",
    backgroundPosition: slide.position || "center top", //*/
    //backgroundSize: "cover",
    //backgroundPosition: "center",
    // backgroundRepeat: "no-repeat",
    // backgroundColor: "#0d1a0e",
  });

  return (
    <section
      style={{
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "80px 32px 120px",
      }}
    >
      {/* Previous slide fades out */}
      {prev !== null && (
        <div
          style={{
            ...bgStyle(SLIDES[prev]),
            zIndex: 0,
            opacity: out ? 0 : 1,
            transition: "opacity 1.2s ease",
          }}
        />
      )}

      {/* Current slide fades in + Ken Burns */}
      <div
        key={cur}
        style={{
          ...bgStyle(SLIDES[cur]),
          zIndex: 1,
          animation:
            "ssIn 1.2s ease forwards, kb 14s ease-in-out infinite alternate",
        }}
      />

      {/* Gradient overlay — keeps text readable over any photo */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 2,
          background:
            "linear-gradient(to bottom, rgba(0,0,0,.22) 0%, rgba(0,0,0,.06) 28%, rgba(0,0,0,.42) 68%, rgba(0,0,0,.76) 100%)",
        }}
      />

      {/* Vignette */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 3,
          background:
            "radial-gradient(ellipse at center, transparent 38%, rgba(0,0,0,.52) 100%)",
        }}
      />

      {/* Botanical SVG */}
      <svg
        viewBox="0 0 360 280"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "240px",
          opacity: 0.2,
          pointerEvents: "none",
          zIndex: 4,
        }}
        aria-hidden="true"
      >
        <g fill="none" stroke="#fff" strokeWidth="1.1" strokeLinecap="round">
          <path d="M-10 260 Q55 185 110 130 Q165 75 185 15" />
          <path
            d="M42 155 Q26 137 34 122 Q48 137 42 155Z"
            fill="rgba(255,255,255,.5)"
            opacity=".55"
          />
          <path
            d="M58 137 Q42 119 50 104 Q64 119 58 137Z"
            fill="rgba(255,255,255,.4)"
            opacity=".5"
          />
          <path
            d="M74 117 Q58 99 66 84 Q80 99 74 117Z"
            fill="rgba(255,255,255,.5)"
            opacity=".55"
          />
          <path
            d="M90 95 Q74 77 82 62 Q96 77 90 95Z"
            fill="rgba(255,255,255,.4)"
            opacity=".5"
          />
          <circle
            cx="120"
            cy="30"
            r="2.5"
            fill="rgba(255,255,255,.6)"
            opacity=".7"
          />
          <circle
            cx="130"
            cy="38"
            r="2"
            fill="rgba(255,255,255,.5)"
            opacity=".6"
          />
        </g>
      </svg>

      {/* ── STATIC TEXT — never moves ── */}
      <div style={{ position: "relative", zIndex: 5 }}>
        <div
          style={{
            fontSize: "13px",
            letterSpacing: ".35em",
            textTransform: "uppercase",
            color: "rgba(255,255,255,.78)",
            fontWeight: 500,
            marginBottom: "24px",
            display: "flex",
            alignItems: "center",
            gap: "14px",
            justifyContent: "center",
            animation: "fadeUp .9s ease forwards",
            opacity: 0,
          }}
        >
          <span
            style={{
              width: "36px",
              height: ".5px",
              background: "rgba(255,255,255,.5)",
              display: "block",
            }}
          />
          The Wedding of
          <span
            style={{
              width: "36px",
              height: ".5px",
              background: "rgba(255,255,255,.95)",
              display: "block",
            }}
          />
        </div>

        <h1
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "clamp(60px,10vw,110px)",
            fontWeight: 400,
            lineHeight: 0.92,
            color: "#fff",
            textShadow: "0 2px 0 rgba(62,102,66,.3),0 6px 28px rgba(0,0,0,.55)",
            animation: "fadeUp 1.1s .15s ease forwards",
            opacity: 0,
          }}
        >
          {WEDDING.groomName}
          <span
            style={{
              fontStyle: "italic",
              color: "#A8C5A0",
              display: "block",
              fontSize: "clamp(34px,5vw,58px)",
              margin: "9px 0",
            }}
          >
            &amp;
          </span>
          {WEDDING.brideName}
        </h1>

        <p
          style={{
            marginTop: "px",
            fontSize: "13px",
            letterSpacing: ".14em",
            textTransform: "uppercase",
            color: "rgba(255,255,255,.8)",
            fontWeight: 400,
            animation: "fadeUp 1.1s .3s ease forwards",
            opacity: 0,
          }}
        >
          {WEDDING.surname} · 11–20 September 2026 · Serowe · Gaborone
        </p>

        <p
          style={{
            marginTop: "28px",
            fontFamily: "var(--font-serif)",
            fontStyle: "italic",
            fontSize: "18px",
            color: "rgba(255,255,255,.82)",
            maxWidth: "460px",
            lineHeight: 1.75,
            animation: "fadeUp 1.1s .45s ease forwards",
            opacity: 0,
          }}
        >
          "Two are better than one, because they have a good return for their
          labor."
          <cite
            style={{
              display: "block",
              fontStyle: "normal",
              fontFamily: "var(--font-sans)",
              fontSize: "9px",
              letterSpacing: ".2em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,.55)",
              marginTop: "8px",
            }}
          >
            Ecclesiastes 4:9
          </cite>
        </p>

        <a
          href="#story"
          style={{
            display: "inline-block",
            marginTop: "40px",
            padding: "12px 30px",
            borderRadius: "28px",
            background: "rgba(255,255,255,.12)",
            border: ".5px solid rgba(255,255,255,.38)",
            backdropFilter: "blur(12px)",
            fontSize: "10px",
            letterSpacing: ".14em",
            textTransform: "uppercase",
            color: "#fff",
            textDecoration: "none",
            animation: "fadeUp 1.1s .6s ease forwards",
            opacity: 0,
          }}
        >
          ✦ Explore Our Story ✦
        </a>
      </div>

      {/* Slide indicator dots */}
      <div
        style={{
          position: "absolute",
          bottom: "52px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "8px",
          alignItems: "center",
          zIndex: 5,
        }}
      >
        {SLIDES.map((_, i) => (
          <div
            key={i}
            onClick={() => setCur(i)}
            style={{
              width: i === cur ? "24px" : "6px",
              height: "6px",
              borderRadius: "3px",
              background:
                i === cur ? "rgba(168,197,160,.95)" : "rgba(255,255,255,.35)",
              cursor: "pointer",
              transition: "all .4s cubic-bezier(.22,1,.36,1)",
            }}
          />
        ))}
      </div>

      {/* Scroll hint */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          fontSize: "9px",
          letterSpacing: ".22em",
          textTransform: "uppercase",
          color: "rgba(255,255,255,.4)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "5px",
          zIndex: 5,
          animation: "bounce 2s infinite",
        }}
      >
        <span>Scroll</span>
        <span>↓</span>
      </div>

      <style>{`
        @keyframes fadeUp { from{opacity:0;transform:translateY(22px);}to{opacity:1;transform:translateY(0);} }
        @keyframes ssIn   { from{opacity:0;}to{opacity:1;} }
        @keyframes kb     { from{transform:scale(1.04) translate(-1%,-0.5%);}to{transform:scale(1.10) translate(1%,0.5%);} }
      `}</style>
    </section>
  );
}
